import type { ErrorComponentProps } from "@tanstack/react-router";
import { useT } from "@/i18n";
import { AccessDeniedError } from "@/lib/auth/guards";
import { useErrorText } from "./error-text";

/**
 * A route that failed to load. A refusal is worded by the server
 * (`useErrorText`); a guard that refused before any request is ours. Nothing
 * about the request or the record is shown.
 */
export function RouteError({ error }: ErrorComponentProps) {
  const { t } = useT();
  const errorText = useErrorText();

  if (error instanceof AccessDeniedError) {
    return (
      <section role="alert" className="px-pad-x py-pad-y">
        <p className="text-fs4 text-ink-1">{t("error.forbidden")}</p>
      </section>
    );
  }

  const message = errorText(error);

  return (
    <section role="alert" className="px-pad-x py-pad-y">
      <p className="text-fs4 text-tone-red">{message}</p>
    </section>
  );
}
